import { UIHeading4 } from '@cian/ui-kit';
import { IconActionFullscreen16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './GenplanBlock.css';

interface IGenplanBlockProps {
  image: string;
  title: string;
  genplan: React.JSX.Element | null;
  onClick(): void;
}

export const GenplanBlock: React.FC<IGenplanBlockProps> = ({ image, title, genplan, onClick }) => {
  return (
    <>
      <div
        className={styles['container']}
        style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})` }}
        onClick={onClick}
      >
        <div className={styles['expand-icon']}>
          <IconActionFullscreen16 color="icon-inverted-default" />
        </div>
        <UIHeading4 color="text-inverted-default">{title}</UIHeading4>
      </div>
      {genplan}
    </>
  );
};
